export default __webpack_public_path__ + "static/media/orange_line.f89198cd.svg";